// 加载 图片
// url 图片 地址 fullPath 表示 全路径
// 默认返回 {width: width / 200 + 'rem', height: height / 200 + 'rem'}rem 格式
export const loadImagePromise = (url, fullPath) => {
  return new Promise(resolve => {
    let img = new Image();
    img.onload = () =>
      resolve(
        fullPath
          ? img
          : { width: img.width / 200 + 'rem', height: img.height / 200 + 'rem' }
      );
    // img.onerror = reject;
    img.onerror = () => {};
    img.src = url;
  });
};

// 获取url参数
// http://wangwang.hhbgrd.com/pay/shopping?shop_id=0a772610-9450-445e-b5a8-bdd9ac358da8
export const getUrlParams = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&'); // eslint-disable-line
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

// 获取全部url参数
export const GetRequest = () => {
  var url = window.location.hash; // 获取url中"?"符后的字串
  var theRequest = new Object();
  if (url.indexOf('?') != -1) {
    var str = url.substr(url.indexOf('?') + 1);
    var strs = str.split('&');
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
    }
  }
  return theRequest;
};
// url插入 参数
// https://developer.mozilla.org/fr/docs/Web/API/URLSearchParams 这个 需要引入 polyfill
// https://stackoverflow.com/questions/1090948/change-url-parameters/10997390#10997390
export const insertParam = (key, value, url) => {
  let TheAnchor = null;
  let newAdditionalURL = '';
  let tempArray = url.split('?');
  let baseURL = tempArray[0];
  let additionalURL = tempArray[1];
  let temp = '';

  if (additionalURL) {
    let tmpAnchor = additionalURL.split('#');
    let TheParams = tmpAnchor[0];
    TheAnchor = tmpAnchor[1];
    if (TheAnchor) additionalURL = TheParams;

    tempArray = additionalURL.split('&');

    for (let i = 0; i < tempArray.length; i++) {
      if (tempArray[i].split('=')[0] != key) {
        newAdditionalURL += temp + tempArray[i];
        temp = '&';
      }
    }
  } else {
    let tmpAnchor = baseURL.split('#');
    let TheParams = tmpAnchor[0];
    TheAnchor = tmpAnchor[1];

    if (TheParams) baseURL = TheParams;
  }

  if (TheAnchor) value += '#' + TheAnchor;

  const rows_txt = temp + '' + key + '=' + value;
  return baseURL + '?' + newAdditionalURL + rows_txt;
};

export const setLocalstorage = (key, data) => {
  localStorage[key] = JSON.stringify(data);
};

export const getLocalstorage = key => {
  const data = localStorage[key];
  return data ? JSON.parse(data) : '';
};

// vue-bus
export const VueBus = Vue => {
  const bus = new Vue();

  Object.defineProperties(bus, {
    on: {
      get() {
        return this.$on;
      }
    },
    once: {
      get() {
        return this.$once;
      }
    },
    off: {
      get() {
        return this.$off;
      }
    },
    emit: {
      get() {
        return this.$emit;
      }
    }
  });

  Vue.bus = bus;

  Object.defineProperty(Vue.prototype, '$bus', {
    get() {
      return bus;
    }
  });
};

export function countDownFormat2(countTime, millisecond) {
  // const t = countTime * 1000; // ms
  const t = +countTime; // m
  let h = Math.floor(t / 3600);
  let m = Math.floor((t - h * 3600) / 60);
  let s = Math.floor(t - h * 3600 - m * 60);
  h = h > 9 ? h : `0${h}`;
  m = m > 9 ? m : `0${m}`;
  s = s > 9 ? s : `0${s}`;
  if (millisecond) {
    const ts = countTime - h * 3600 - m * 60 - s;
    const ms = Math.floor(ts / 100);
    return `${h}:${m}:${s}.${ms}`;
  }
  return `${h}:${m}:${s}`;
}

export function countDownFormat(countTime, millisecond) {
  // const t = countTime * 1000; // ms
  const t = +countTime; // m
  let d = Math.floor(t / 86400);
  let h = Math.floor((t - d * 86400) / 3600);
  let m = Math.floor((t - d * 86400 - h * 3600) / 60);
  let s = Math.floor(t - d * 86400 - h * 3600 - m * 60);
  d = d ? `${d}天` : '';
  h = h > 9 ? h : `0${h}`;
  m = m > 9 ? m : `0${m}`;
  s = s > 9 ? s : `0${s}`;
  if (millisecond) {
    const ts = countTime - d * 86400 - h * 3600 - m * 60 - s;
    const ms = Math.floor(ts / 100);
    return `${d}${h}:${m}:${s}.${ms}`;
  }
  if (d > 0) {
    return `${d}${h}:${m}:${s}`;
  }
  return `${h}:${m}:${s}`;
}


// WEBPACK FOOTER //
// ./src/lib/common.js